<template>
  <div class="w-100">
    <div class="f-row-start w-100 branchbox">
      <div class="w-100" v-if='listData.length>0'>
        <el-carousel indicator-position="none" :autoplay='false' height='118px' ref='img'>
          <el-carousel-item v-for="(items,aind) in listData" :key="aind">
            <div class="f-row-l wrap w-100">
              <div class="item pinter" v-for="(item,ind) in items" :key='ind' @click="goPage('news',15,item.id)">
                <div class="f-row-c imgbox">
                  <img :src="$imgUrl+item.breviaryMap"/>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: ['list'],
  data() {
    return {
      arr: JSON.parse(this.list),
      listData: []
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.getData()
    });

  },
  methods: {
    goPage(url, type, id) {
      this.$util.goTop()
      var params = {}
      if (type) {
        params.type = type
      }
      if (id) {
        params.id = id
      }
      this.$router.push({
        path: url,
        query: params
      })
    },
    getData() {
      // console.log(222,this.arr)
      if (this.arr.length > 0) {
        this.listData = [[]]
        var j = 0
        for (var i = 0; i < this.arr.length; i++) {
          this.listData[j].push(this.arr[i])
          if ((i * 1 + 1) % 4 == 0) {
            j = j * 1 + 1
            this.listData[j] = []
          }
        }
        var len = this.listData.length
        if (len > 1 && (this.listData[len - 1].length == 0)) {
          this.listData = this.listData.slice(0, len - 1)
        }
      }
    }
  }

}
</script>
<style lang='scss' scoped>
.branchbox {
  position: relative;
  margin-top: 25px;
  margin-bottom: 25px;
}

.item {
  width: 25%;
  height: 118px;
  color: #333333;
  font-size: 14px;

  .imgbox {
    width: 100%;
    height: 100%;
    padding-right: 10px;
    position: relative;

    img {
      width: 100%;
      height: auto;
    }
  }

  .imgbox:nth-child(4) {
    padding-right: 0px;
  }

}

.el-carousel__item {
  .img {
    width: 100%;
  }
}

.imgbox:hover {
  > img {
    transform: scale(1.2);
  }
}
</style>